'use strict';

exports.__esModule = true;

var _getEventPreprocessor = require('../../utils/getEventPreprocessor');

var _getEventPreprocessor2 = _interopRequireDefault(_getEventPreprocessor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _getEventPreprocessor2['default'])('stopPropagation', 'stopPropagation');


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/events/stopPropagation.js
// module id = 572
// module chunks = 1